import { useCallback, useEffect, useState } from "react";
import { fetchVehicleBrands, fetchVehicleModels, addVehicleBrand, addVehicleModel } from "../../models/shared/vehiclesModel";

export function useVehicleLookup() {
  const [brands, setBrands] = useState([]);
  const [brandsLoading, setBrandsLoading] = useState(true);
  const [models, setModels] = useState([]);
  const [modelsLoading, setModelsLoading] = useState(false);

  useEffect(() => {
    fetchVehicleBrands().then(list => {
      setBrands(list);
      setBrandsLoading(false);
    });
  }, []);

  const loadModels = useCallback(async (brandId) => {
    if (!brandId) {
      setModels([]);
      return;
    }
    setModelsLoading(true);
    const list = await fetchVehicleModels(brandId);
    setModels(list);
    setModelsLoading(false);
  }, []);

  const addBrand = useCallback(async (name) => {
    const res = await addVehicleBrand(name);
    if (res.success) setBrands(res.data.map(item => ({ value: item.id, label: item.name })));
    return res;
  }, []);

  const addModel = useCallback(async (brandId, modelName) => {
    const res = await addVehicleModel(brandId, modelName);
    if (res.success) setModels(res.data.map(item => ({ value: item.id, label: item.model })));
    return res;
  }, []);

  return { brands, brandsLoading, models, modelsLoading, loadModels, addBrand, addModel };
}
